import ApiService from "../../api/api";
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            isTabTree: false
        }
    },
    getters: {
        isTabTree: (state) => {
            return state.isTabTree;
        }
    },
    mutations: {
        setSwitchTab(state, value) {
            state.isTabTree = value;
        }
    },
};
